import React from 'react'

const TubeSVG = ({ size, length }) => {
  const rectWidth = parseFloat(length) + 120

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="6130" height="150" viewBox="0 0 6130 150">
      <defs>
        <linearGradient id="linear-gradient" x1="0.5" x2="0.5" y2="1" gradientUnits="objectBoundingBox">
          <stop offset="0" stopColor="#d1d1d1"/>
          <stop offset="0.305" stopColor="#6e6e6e"/>
          <stop offset="0.502" stopColor="#5a5a5a"/>
          <stop offset="1" stopColor="#c6c6c6"/>
        </linearGradient>
      </defs>
      <g id="Group_1" data-name="Group 1" transform="translate(-100 -100)">
        <g id="Rectangle_1" data-name="Rectangle 1" transform="translate(115 100)" stroke="#000" strokeWidth="4" fill="url(#linear-gradient)">
          <rect width={rectWidth} height="150" rx="75" stroke="none"/>
          <rect x="2" y="2" width={rectWidth - 4} height="146" rx="73" fill="none"/>
        </g>
        <g id="Ellipse_1" data-name="Ellipse 1" transform="translate(100 100)" fill="#a7a7a7" stroke="#000" strokeWidth="4">
          <circle cx="75" cy="75" r="75" stroke="none"/>
          <circle cx="75" cy="75" r="73" fill="none"/>
        </g>
        <g id="Ellipse_2" data-name="Ellipse 2" transform="translate(115 115)" stroke="#000" strokeWidth="4">
          <circle cx="60" cy="60" r="60" stroke="none"/>
          <circle cx="60" cy="60" r="58" fill="none"/>
        </g>
      </g>
    </svg>
  )
}

export default TubeSVG
